import styles from "./styles.module.scss";
import { ReactComponent as OutlineCheckSmall } from "assets/svg/outline-check-small.svg";
import { useEffect, useState } from "react";
import messages from "messages";

type Props = {
  show: boolean;
  onHide?: () => void;
  /**
   * tag message
   * @default "Saved"
   */
  message?: string;
  /**
   * duration for the saved tag to show
   * @default 2000
   */
  duration?: number;
};
const SavedTag = ({ show, onHide, duration, message }: Props) => {
  const [localShow, setLocalShow] = useState(show);

  useEffect(() => setLocalShow(show), [show]);

  useEffect(() => {
    if (!localShow) {
      return;
    }
    const timer = setTimeout(() => {
      setLocalShow(false);
      onHide && onHide();
    }, duration ?? 2000);

    return () => timer && clearTimeout(timer);
  }, [localShow, onHide, duration]);

  return localShow ? (
    <div className={styles["saved-tag"]}>
      <div className={styles["saved-tag__content"]}>
        <OutlineCheckSmall />
        <div className="ml-2">{message || messages.saved}</div>
      </div>
    </div>
  ) : null;
};

export default SavedTag;
